import { render, staticRenderFns } from "./RejectedIcon.vue?vue&type=template&id=a4487abe&"
import script from "./RejectedIcon.vue?vue&type=script&lang=js&"
export * from "./RejectedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports